/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  CredentialIssuedListsService,
  ICredentialListsMethods,
  IRevokeCredentialMethods,
  RevokeCredentialService,
  LoadingService,
  ILoadingMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
} from "./components";

export type MyCredentialsPageAgent = IHeaderMethods &
  ISettingsMethods &
  ICredentialListsMethods &
  IRevokeCredentialMethods &
  IStaticPageContentMethods &
  ILoadingMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new CredentialIssuedListsService(),
    new RevokeCredentialService(),
    new LoadingService(),
    new StaticPageContentService(),
  ];
};

export const getAgent = () => {
  return createAgent<MyCredentialsPageAgent>({
    plugins: getPlugins(),
  });
};
